import { territoriesConstants } from '../constants/territories';
import { territoriesFormatter } from '../formatters/territories';
import { territoriesService } from '../services/territories';

export const territoriesActions = {
    getRollingMonthsRevenue,
    getTerritories,
};

function getRollingMonthsRevenue(filter) {
    return ( dispatch, getState ) => {
        dispatch(request());
        return territoriesService.getRollingMonthsRevenue(filter)
            .then(
                ({result}) => {
                    const { data, pie, timeseries } = territoriesFormatter.formatRollingMonthsRevenue(result);
                    dispatch(success(data, pie, timeseries));
                    return data;
                },
                error => {
                    dispatch(failure('error'))
                }
            );
    };

    function request() { return { type: territoriesConstants.GET_ROLLING_MONTHS_REVENUE_REQUEST } }
    function success(months, monthPie, monthTimeseries) { return { type: territoriesConstants.GET_ROLLING_MONTHS_REVENUE_SUCCESS, months, monthPie, monthTimeseries } }
    function failure(error) { return { type: territoriesConstants.GET_ROLLING_MONTHS_REVENUE_FAILURE, error } }
}

function getTerritories(filter) {
    return ( dispatch, getState ) => {
        dispatch(request());

        territoriesService.getTerritories(filter)
            .then(
                ({result}) => {
                    result = territoriesFormatter.formatTerritories(result);
                    dispatch(success(result));
                },
                error => {
                    dispatch(failure('error'))
                }
            );
    };

    function request() { return { type: territoriesConstants.GET_TERRITORIES_REQUEST } }
    function success(metrics) { return { type: territoriesConstants.GET_TERRITORIES_SUCCESS, metrics } }
    function failure(error) { return { type: territoriesConstants.GET_TERRITORIES_FAILURE, error } }
}
